export default __webpack_public_path__ + "static/images/brokerage.7dbba490.png";